import services from 'services'
import stringify from 'qs/lib/stringify'
import Raven from 'raven-js'

export default {
  send(params) {
    const allParams = {
      ...params,
      sr: `${window.screen.width}x${window.screen.height}`,
      vp: `${document.documentElement.clientWidth}x${document.documentElement.clientHeight}`,
      // cache buster
      z: Math.round(2147483647 * Math.random()),
    }
    try {
      return services.fetch(`/v1/aarne?${stringify(allParams)}`)
    } catch (error) {
      Raven.captureException(error, {
        extra: allParams,
      })
    }
  },

  trackPageView(path) {
    this.send({
      t: 'pageview',
      dp: path || window.location.pathname,
    })
  },

  trackEvent(args) {
    this.send({ ...args, t: 'event' })
  },
}
